import React from "react";
import { motion } from "framer-motion";

export default function EmptyState({ title = "Nothing here yet", description, action }) {
  return (
    <motion.div
      className="pm-empty"
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35 }}
    >
      <div className="pm-empty__mark">◇</div>
      <h3>{title}</h3>
      {description && <p>{description}</p>}
      {action}
    </motion.div>
  );
}
